import type { PropsWithChildren } from 'react';

export default function RootGestureWrapper({ children }: PropsWithChildren) {
  return children;
}
